export default {
    'Menu': 'منو'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/oncanvas/translations/fa.js
// module id = 96
// module chunks = 0